import preferences from 'Preferences';
import {Thunk} from 'redux-stores/Store';
import {ScrollableTablePreferences} from 'ui-library/scrollable/ScrollableTableConstants';

export enum ScrollableTableUIActionType {
  HIDDEN_COLUMNS_UPDATED = 'HIDDEN_COLUMNS_UPDATED',
  COLUMN_ORDER_UPDATED = 'COLUMN_ORDER_UPDATED',
}

interface UpdateHiddenColumnsAction {
  type: ScrollableTableUIActionType.HIDDEN_COLUMNS_UPDATED;
  tableKey: string;
  hiddenColumnKeys: Array<string>;
}

interface UpdateColumnOrderAction {
  type: ScrollableTableUIActionType.COLUMN_ORDER_UPDATED;
  tableKey: string;
  columnOrderKeys: Array<string>;
}

export function hiddenColumnsUpdated(
  tableKey: string,
  hiddenColumnKeys: Array<string>
): UpdateHiddenColumnsAction {
  return {
    type: ScrollableTableUIActionType.HIDDEN_COLUMNS_UPDATED,
    tableKey,
    hiddenColumnKeys,
  };
}

export function updateHiddenColumns(tableKey: string, hiddenColumnKeys: Array<string>): Thunk<void> {
  return (dispatch) => {
    preferences.set(`${tableKey}${ScrollableTablePreferences.HIDDEN_COLUMN_NAMESPACE}`, hiddenColumnKeys);
    dispatch(hiddenColumnsUpdated(tableKey, hiddenColumnKeys));
  };
}

export function columnOrderUpdated(
  tableKey: string,
  columnOrderKeys: Array<string>
): UpdateColumnOrderAction {
  return {
    type: ScrollableTableUIActionType.COLUMN_ORDER_UPDATED,
    tableKey,
    columnOrderKeys,
  };
}

export function updateColumnOrder(tableKey: string, columnOrderKeys: Array<string>): Thunk<void> {
  return (dispatch) => {
    preferences.set(`${tableKey}${ScrollableTablePreferences.COLUMN_ORDER_NAMESPACE}`, columnOrderKeys);
    dispatch(columnOrderUpdated(tableKey, columnOrderKeys));
  };
}

export type ScrollableTableUIAction = UpdateHiddenColumnsAction | UpdateColumnOrderAction;
